import React, { useState, useEffect } from "react";
import Header from "../../components/ui/Header";
import Button from "../../components/ui/Button";

import Icon from "../../components/AppIcon";
import NotificationTable from "./components/NotificationTable";
import NotificationFormModal from "./components/NotificationFormModal";
import NotificationViewModal from "./components/NotificationViewModal";
import DeleteConfirmModal from "../users-crud-management/components/DeleteConfirmModal";
import { useDispatch, useSelector } from "react-redux";
import {
  createNotificationService,
  deleteNotificationsService,
  getNotificationsService,
} from "redux/services/general_service";
import { toast } from "react-toastify";

const PushNotificationsCrudManagement = () => {
  const dispatch = useDispatch();

  const { notifications, metaNotifications } = useSelector(
    (state) => state.general,
  );

  const [language, setLanguage] = useState("ar");

  const [searchQuery, setSearchQuery] = useState("");
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [formMode, setFormMode] = useState("add");

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "ar";
    setLanguage(savedLanguage);
  }, []);

  const labels = {
    title: {
      en: "Push Notifications Management",
      ar: "إدارة الإشعارات الفورية",
    },
    addNew: { en: "Add New Notification", ar: "إضافة إشعار جديد" },
    search: { en: "Search notifications...", ar: "البحث عن الإشعارات..." },
    noResults: {
      en: "No notifications found",
      ar: "لم يتم العثور على إشعارات",
    },
  };

  const handleAddItem = () => {
    setFormMode("add");
    setSelectedItem(null);
    setIsFormModalOpen(true);
  };

  const handleEditItem = (item) => {
    setFormMode("edit");
    setSelectedItem(item);
    setIsFormModalOpen(true);
  };

  const handleViewItem = (item) => {
    setSelectedItem(item);
    setIsViewModalOpen(true);
  };

  const handleDeleteItem = (item) => {
    setSelectedItem(item);
    setIsDeleteModalOpen(true);
  };

  const handleSaveItem = (itemData) => {
  dispatch(createNotificationService(itemData)).then((response) => {
      if (
        response?.payload?.status === 200 ||
        response?.payload?.status === 201
      ) {
        dispatch(getNotificationsService({ page: 1 }));
        toast("تم الحذف بنجاح");
        setIsFormModalOpen(false);
      } else {
        Object.values(response.payload.response?.data?.errors)
          .flatMap((errorArray) => errorArray)
          .forEach((error) => toast.warn(error));
      }
    });
  };

  const handleConfirmDelete = () => {
    
    dispatch(deleteNotificationsService(selectedItem.id)).then((response) => {
      if (
        response?.payload?.status === 200 ||
        response?.payload?.status === 201
      ) {
        dispatch(getNotificationsService({ page: 1 }));
        toast("تم الحذف بنجاح");
        setIsDeleteModalOpen(false);
      } else {
        Object.values(response.payload.response?.data?.errors)
          .flatMap((errorArray) => errorArray)
          .forEach((error) => toast.warn(error));
      }
    });
  };

  const handleSendNow = (item) => {
    alert(
      `Sending notification: "${item?.title}" to ${item?.targetUsers?.length} users`,
    );
  };

  const filteredData = notifications?.filter(
    (item) =>
      item?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      item?.message?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      item?.type?.toLowerCase()?.includes(searchQuery?.toLowerCase()),
  );

  useEffect(() => {
    dispatch(getNotificationsService());
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container mx-auto px-4 py-6 md:py-8">
        <div className="bg-card rounded-xl shadow-elevation-2 border border-border overflow-hidden">
          <div className="px-4 py-4 md:px-6 md:py-6 border-b border-border">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="p-2 md:p-3 rounded-lg bg-primary/10">
                  <Icon name="Bell" size={24} className="text-primary" />
                </div>
                <div>
                  <h1 className="text-xl md:text-2xl font-bold text-foreground">
                    {labels?.title?.[language]}
                  </h1>
                  <p className="text-sm text-text-secondary mt-1">
                    {language === "en"
                      ? "Manage push notifications and alerts"
                      : "إدارة الإشعارات والتنبيهات الفورية"}
                  </p>
                </div>
              </div>
              <Button onClick={handleAddItem} iconName="Plus" size="default">
                {labels?.addNew?.[language]}
              </Button>
            </div>
          </div>

          <div className="px-4 py-4 md:px-6 border-b border-border">
            <div className="relative">
              <Icon
                name="Search"
                size={18}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary"
              />
              <input
                type="text"
                placeholder={labels?.search?.[language]}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e?.target?.value)}
                className="w-full pl-10 pr-4 py-2 rounded-lg border border-border bg-background text-foreground placeholder:text-text-secondary focus:outline-none focus:ring-2 focus:ring-ring"
              />
            </div>
          </div>

          {filteredData?.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 md:py-16">
              <Icon name="Bell" size={48} className="text-muted mb-4" />
              <p className="text-text-secondary text-base">
                {labels?.noResults?.[language]}
              </p>
            </div>
          ) : (
            <NotificationTable
              data={filteredData}
              language={language}
              onEdit={handleEditItem}
              onDelete={handleDeleteItem}
              onView={handleViewItem}
              onSendNow={handleSendNow}
            />
          )}
        </div>
      </div>

      <NotificationFormModal
        isOpen={isFormModalOpen}
        onClose={() => setIsFormModalOpen(false)}
        onSave={handleSaveItem}
        item={selectedItem}
        mode={formMode}
        language={language}
      />

      <NotificationViewModal
        isOpen={isViewModalOpen}
        onClose={() => setIsViewModalOpen(false)}
        item={selectedItem}
        language={language}
        onEdit={() => {
          setIsViewModalOpen(false);
          handleEditItem(selectedItem);
        }}
        onDelete={() => {
          setIsViewModalOpen(false);
          handleDeleteItem(selectedItem);
        }}
        onSendNow={() => {
          handleSendNow(selectedItem);
          setIsViewModalOpen(false);
        }}
      />

      <DeleteConfirmModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
        itemName={selectedItem?.title}
        language={language}
      />
    </div>
  );
};

export default PushNotificationsCrudManagement;
